import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { TonKhoHienTai, UpdateNoteQARequestBody, UpdateTagInfoRequestBody } from '../ton-kho-hien-tai-model/ton-kho-hien-tai.model';
const API_ROOT_URL = environment.ApiRoot + '/kho';

@Injectable()
export class TonKhoHienTaiService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	lastExportDataFile:BehaviorSubject<{}>=new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/TonKhoHienTai_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	listHangHoa() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/Hang_Hoa_List' ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	listKho() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/Kho_List' ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	XuatExcelTongHopTonKhoHT(queryParams:QueryParamsModel) {

		
		let _this= this;
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		var request = new XMLHttpRequest();
		var link = API_ROOT_URL + `/ExportFileTongHopTonKhoHienTai?`+httpParams.toString();
		request.open("GET", link);
	
		request.responseType = 'arraybuffer';
		request.onload = function (e) {
			var name = 'Tồn kho hiện tại.xlsx';
			var file = new Blob([this.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			if (navigator.msSaveBlob) {
				return navigator.msSaveBlob(file);
			}
			
			var a = document.getElementById("downloadfile");

			var url = window.URL.createObjectURL(file);
			a.setAttribute("href", url);
			a.setAttribute("download", name);

			a.click();

			window.URL.revokeObjectURL(url);
			_this.lastExportDataFile.next(file)
		};
		
		request.send();
		
	
	}
	ChangeTag(item: UpdateTagInfoRequestBody): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<UpdateTagInfoRequestBody>(API_ROOT_URL+'/updatetonkhohientaitag', item, { headers: httpHeaders });
	}
	ChangeGhiChu(item: UpdateNoteQARequestBody): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<UpdateNoteQARequestBody>(API_ROOT_URL+'/TonKhoHienTai_Update_GhiChu', item, { headers: httpHeaders });
	}

	export_current_inventory_data(queryParams: QueryParamsModel): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<Blob>(API_ROOT_URL + '/export_current_inventory_data', {
		  headers: httpHeaders,
		  params: httpParams,
		  responseType: 'blob' as 'json'
		});
	}

	get_current_inventory_data(queryParams: QueryParamsModel): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/get_current_inventory_data', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	get_current_inventory_data_histories(
		currentInventoryId: number
	): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set('currentInventoryId', currentInventoryId.toString());
		return this.http.get<any>(API_ROOT_URL + '/get_current_inventory_data_histories', {
			headers: httpHeaders,
			params: httpParams
		});
	}
}
